import React, {useState} from "react";
import {useSelector} from "react-redux";
import {selectLang, Translate} from "../../../../app/store/reducers/main/mainReducer";
import {syncEmpowermentV2Async} from "../../../../app/store/reducers/roaming/roamingEmpowermentV2Reducer";
import IconButton from "../../../common/IconButton";
import PropTypes from "prop-types";

const SyncEmpowermentV2 = ({id, ...props}) => {
    const lang = useSelector(selectLang);
    const t = Translate;

    const [loading, setLoading] = useState(false);
    const syncEmpowermentV2 = () => {
        setLoading(true);
        syncEmpowermentV2Async(id)
            .then()
            .catch()
            .finally(() => setLoading(false))
    };

    return (
        <IconButton
            icon={'fa-refresh'}
            variant="falcon-primary"
            onClick={syncEmpowermentV2}
            size="sm"
            iconClassName="me-1"
            disabled={loading}
            {...props}>
            {t(lang, "roaming.empowerment.sync")}
        </IconButton>
    )
};

SyncEmpowermentV2.propTypes = {
    id: PropTypes.string
}

SyncEmpowermentV2.defaulProps = {
    id: ""
}

export default SyncEmpowermentV2;
